import { useContext } from "react";
import { CARD_HEIGHT, CARD_WIDTH } from "../../config/layoutConfig";
import { urlParamsFromStoreType } from "../../library/urlParamsFromStoreType";
import { AppContext } from "../../context";
import IconAndStoreName from "./cardComponents/IconAndStoreName";
import PricesFrom from "./cardComponents/PricesFrom";
import StoreCardIcons from "./cardComponents/StoreCardIcons";
import StoreMainImage from "./cardComponents/StoreMainImage";
import VillageList from "./cardComponents/VillageList";
import "./StoreCard.css";
import { ENTITIES } from "../../entities/entitiesConfig";

export function StoreCard({ store }) {
  const info = useContext(AppContext);

  const languagePath = () => {
    return info.language === "pt" ? "" : "/" + info.language;
  };

  return (
    <div
      className="ahp-store-card"
      style={{
        width: CARD_WIDTH,
        height: CARD_HEIGHT,
        cursor: "pointer",
      }}
    >
      <StoreMainImage store={store} />

      {store?.minimum_price && <PricesFrom store={store} />}

      <div className="ahp-store-title-overlay" style={{ width: CARD_WIDTH }}>
        <IconAndStoreName store={store} />
        <div
          id="teste"
          className="ahp-store-card-description"
          dangerouslySetInnerHTML={{
            __html: `${
              store?.description &&
              (store?.description[info.language]
                ? store?.description[info.language]
                : store?.description["pt"]
                ? store?.description["pt"]
                : // legacy - some stores had "pt-pt" as the key for portuguese in the description
                  store?.description["pt-pt"])
            }`,
          }}
        ></div>

        <a
          className="ahp-seemore-btn"
          href={
            `${languagePath()}/${ENTITIES[store?.type].subDir}/${store?.slug}` +
            urlParamsFromStoreType(store, info)
          }
        >
          {info.t("open")}
        </a>
      </div>

      <VillageList store={store} />
      <StoreCardIcons store={store} />
    </div>
  );
}
